import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Icon } from '@node-space/ui-components'
import AbsoluteLayout from 'components/layout/AbsoluteLayout'
import { PathNames } from 'constants/General'

const NotFound = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <AbsoluteLayout>
      <div className="w-full h-screen flex flex-col sm:mx-0 mx-4">
        <div className="flex justify-center w-full h-full">
          <div className="flex flex-col">
            <h1 className="text-h1 text-foreground-prominent mt-8 md:mt-16 text-center">
              404 - {t('notFound')}
            </h1>
            <div>
              <Button
                full
                iconElement={<Icon name="ArrowUUpLeft" />}
                className="mt-6"
                onClick={() => navigate(PathNames.DASHBOARD)}
              >
                Go Home
              </Button>
            </div>
          </div>
        </div>
      </div>
    </AbsoluteLayout>
  )
}

export default NotFound
